import MaterialThemeProvider from '@/components/MaterialThemeProvider/MaterialThemeProvider';

export default MaterialThemeProvider;
